import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api, pickLocale } from '@/lib/api';
import { Img } from '@/lib/ui';
import { useSEO } from '@/lib/useSEO';

export default function Blog() {
  const { t, i18n } = useTranslation();
  useSEO({ title: 'Blog & News', description: 'Latest news, blogs and field updates from Universal Krishna Gaukul Mission.' });
  const lang = i18n.language.split('-')[0];
  const { data: items = [], isLoading } = useQuery({ queryKey: ['blog'], queryFn: async () => (await api.get('/blog')).data });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-testid="blog-page">
      <h1 className="font-serif text-4xl md:text-6xl text-ukgm-blue font-semibold leading-tight">{t('blog.title')}</h1>
      <p className="mt-4 max-w-2xl text-ukgm-slate text-lg">{t('blog.subtitle')}</p>

      {!isLoading && items.length > 0 && (
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(b => (
            <Link key={b.slug} to={`/blog/${b.slug}`} className="group bg-white rounded-2xl overflow-hidden border border-ukgm-gold/20 card-lift" data-testid={`blog-item-${b.slug}`}>
              {b.cover_image && (
                <div className="h-48 overflow-hidden">
                  <Img src={b.cover_image} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
              )}
              <div className="p-5">
                <div className="text-xs text-ukgm-gold uppercase tracking-widest font-bold">{t('blog.author_by')} {b.author}</div>
                <h3 className="mt-2 font-serif text-lg text-ukgm-blue font-semibold group-hover:text-ukgm-gold">{pickLocale(b.title, lang)}</h3>
                <p className="mt-2 text-sm text-ukgm-slate line-clamp-3">{pickLocale(b.excerpt, lang)}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
